import { Component, OnInit, HostListener, Input, KeyValueDiffer, KeyValueDiffers, KeyValueChanges, Output, EventEmitter } from '@angular/core';
import { Model } from 'src/app/Models/model';
import { ListInterface } from 'src/app/Inteface/list-interface';
import { CdkDragDrop, CdkDragMove, CdkDragStart, CdkDragEnd } from '@angular/cdk/drag-drop';
import { DragDropService } from '../../../Services/drag-drop.service'
import { StepServiceService } from 'src/app/Services/step-service.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { AuthenticationService } from 'src/app/Services/authentication.service';
import { Router } from '@angular/router';
import { AddElementComponent } from '../../add-element/add-element.component';
import { MatDialog } from '@angular/material';
import { CodeLinkageViewComponent } from 'src/app/Views/code-linkage-view/code-linkage-view.component';
@Component({
  selector: 'ze-object-list-linear',
  templateUrl: './object-list-linear.component.html',
  styleUrls: ['./object-list-linear.component.scss']
})
export class ObjectListLinearComponent implements OnInit {
  @Output("onDelete") event = new EventEmitter();
  @Output("onEdit") editEvent = new EventEmitter();
  @Output("onSaveAs") saveAsEvent = new EventEmitter();
  @Input("listInteface") list: ListInterface;
  @Input("active") active: boolean;
  @Input("showStep") showStep: boolean = false;
  @Input("listfor") listfor: string;
  @Input("filter")
  set filter(filter: string) {
    this.filterProperty = filter.split(":")[0];
    this.filterQuery = filter.split(":")[1];
    if (this.list.models == undefined || this.list.models == null)
      this.list.models = [];
    this.models = this.transform(this.list.models, this.filterProperty as string, this.filterQuery as string);
    this.selected = 0;
  }
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.active) {
      if (event.key == "ArrowUp" && this.selected > 0) {
        this.selected--;
      }
      if (event.key == "ArrowDown" && this.selected < this.models.length - 1) {
        this.selected++;
      }
      if (event.key == "Enter") {
        this.list.onClick(this.models[this.selected]);
        this.selected = 0;
      }
    }
  }
  private differ: KeyValueDiffer<string, any>;
  contextAvailable: boolean;
  selected: number;
  filterProperty: string;
  filterQuery: string;
  objectIdPropertyName: string;
  models: Model[];
  moreMenuModel: Model;
  constructor(
    private differs: KeyValueDiffers,
    private dnd: DragDropService,
    private stepService: StepServiceService,
    private notifys: NotifyService,
    private authenticationService: AuthenticationService,
    private router: Router,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.list.listItemHeadingProperyName;
    this.selected = -1;
    if (this.list.models == undefined || this.list.models == null)
      this.list.models = [];
    this.models = this.transform(this.list.models, "name", "");
    this.differ = this.differs.find(this.list.models).create();
    this.contextAvailable = (this.list.modelService != undefined);
  }
  ngDoCheck(): void {
    const changes = this.differ.diff(this.list.models);
    if (changes) {
      this.modelChanged(changes);
    }
  }
  modelChanged(changes: KeyValueChanges<string, any>) {
    changes.forEachRemovedItem((record) => {
      this.updateList();
    });
    changes.forEachAddedItem((record) => {
      this.updateList();
    });
    changes.forEachChangedItem((record) => {
      this.updateList();
    });
  }
  updateList() {
    this.models = this.transform(this.list.models, "name", "");
  }
  transform(input: any[], property: string, filter: string): any {
    if (input != undefined)
      return input.filter(function (element, index, array) {
        if (element[property] != undefined && element[property].trim().toLowerCase().includes(filter.toLowerCase())) {
          return element;
        }
      });
  }
  saveStep(data) {
    this.stepService.saveStep(data).subscribe(data => {
      this.notifys.notify('warning', 'Saved to Library', 'will be removed from step list');
    })
  }
  deleteModel(data) {
    this.event.emit(data);
  }
  editModel(data) {
    this.editEvent.emit(data);
  }
  setMoreMenuModel(model: Model) {
    this.moreMenuModel = model;
  }
  drop(event: CdkDragDrop<any[]>) {
    this.dnd.drop(event);
  }
  moveElement(event: CdkDragMove<string[]>) {
  }

  onDragStarted(event: CdkDragStart): void {
    this.dnd.onDragStarted();
  }

  onDragEnded(event: CdkDragEnd): void {
    this.dnd.onDragEnded();
  }
  saveAsModel(data) {
    this.saveAsEvent.emit(data);
  }
  openCodeLinkageView(data) {
    this.dialog.open(CodeLinkageViewComponent, {
      width: '99%',
      height: '96%',
      disableClose: true,
      data: {
        artifactType: data._type,
        artifactId: data._id,
      },
      backdropClass: 'overlay-backdrop-dark-class',
    });
  }

  createEnvFile(data: any) {
    console.log("suite id is", data)
    let dialogRef = this.dialog.open(AddElementComponent, {
      data: {
        event: 'Pwd',
        title: 'Enter password:',
        name: ''
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.name) {
        this.notifys.notify('warning', 'No password entered', 'Operation cancelled');
        return;
      }

      const enteredPassword = result.name;
      const currentUsername = localStorage.getItem('username');

      this.authenticationService.login(currentUsername, enteredPassword).subscribe(
        () => {
          const scriptContent = `#!/bin/bash
set -e  # Exit script on first error
set -o pipefail  # Fail if any command in a pipeline fails
set -x  # Debug mode


# Define environment variables
API_BASE_URL="https://dev.server.xpeer.ai:8080"
API_USERNAME="${localStorage.getItem('username')}"
API_PASSWORD="${result.name}"
PROJECT_ID="${localStorage.getItem('projectId')}"
SUITE_ID="${data._id}"
BROWSER="chrome"
HUB_IP="11.0.133.181"
PORT="4445"

#  Step 1: Authenticate
echo "Authenticating with $API_BASE_URL/authenticate"

RESPONSE=$(curl -s -X POST "$API_BASE_URL/authenticate" \\
  -H "Content-Type: application/json" \\
  -d '{"username": "'"$API_USERNAME"'", "password": "'"$API_PASSWORD"'", "loginType": "EXTENSION"}')

TOKEN=$(echo "$RESPONSE" | jq -r '.token')

if [[ "$TOKEN" == "null" || -z "$TOKEN" ]]; then
    echo "Authentication failed!"
    exit 1
fi

echo "Authentication successful!"


# Create JSON payload
echo '{
  "project": { "_id": "'"$PROJECT_ID"'" },
  "execution": {
    "suite_id": "'"$SUITE_ID"'",
    "browser": ["'"$BROWSER"'"],
    "hub_ip": "'"$HUB_IP"'",
    "port": '"$PORT"',
    "send_mail": false,
    "resolution": "1920x1200",
    "screenshot_required": false,
    "default_hub": true,
    "local_execution": false,
    "execution_machine": "Default Machine"
  }
}' > request.json

# Debugging: Verify the JSON file was created
if [ ! -f request.json ]; then
  exit 1
fi

cat request.json

# Validate JSON format before sending
jq . request.json > /dev/null || { echo "Invalid JSON"; exit 1; }

# Step 3: Send API Request
if [ -f optional_file.zip ]; then
  HTTP_RESPONSE=$(curl -s -o response.json -w "%{http_code}" -X POST "$API_BASE_URL/execute/executeSuite" \\
    -H "Authorization: Bearer $TOKEN" \\
    -H "Content-Type: multipart/form-data" \\
    -F "req=$(<request.json)" \\
    -F "file=@optional_file.zip")
else
  HTTP_RESPONSE=$(curl -s -o response.json -w "%{http_code}" -X POST "$API_BASE_URL/execute/executeSuite" \\
    -H "Authorization: Bearer $TOKEN" \\
    -H "Content-Type: multipart/form-data" \\
    -F "req=$(<request.json)" \\
    -F "file=@/dev/null")
fi

echo "HTTP Status Code: $HTTP_RESPONSE"

if [[ "$HTTP_RESPONSE" -ne 200 ]]; then
  echo "Error: API request failed with status code $HTTP_RESPONSE"
  exit 1
fi`;

          const fileName = 'Xpeer.sh';
          const blob = new Blob([scriptContent], { type: 'text/plain' });
          const anchor = document.createElement('a');
          anchor.href = window.URL.createObjectURL(blob);
          anchor.download = fileName;
          anchor.click();

          console.log('Script file generated:', fileName);
        },
        (err) => {
          this.notifys.notify('error', 'Incorrect password', 'The entered password does not match your account');
          console.error('Password validation failed', err);
        }
      );

    });
  }

  isLibrary(): boolean {
    return window.location.href.includes('/library');
  }
}
